import AutoQuery from 'servicestack/auto-query/auto-query'
import ServiceBus from 'servicestack/service-bus'
import BasicController from 'servicestack/basic.controller'
import $session from 'servicestack/session'
import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'
import templateUrl from 'servicestack/messaging/entity-message-prompt.htm'
import config from 'emun.customer/customer.config'
import VideoMessagePrompt from 'servicestack/video-message/video-message-prompt.es6'

function EntityMessagePromptController($rootScope, $uibModalInstance, options) {
    var $ctrl = this;
    var model = $ctrl.model = options.model;
    var bus = $ctrl.bus = new ServiceBus($rootScope);
    $ctrl.title = 'Enter Note...';
    $ctrl.config = config;


    if (options.title) {
		$ctrl.title = options.title;
	}

        $ctrl.loadMessages = function() {
        const $ctrl = this;
        $ctrl.bus.read("QueryEntityMessages.json", {
            orderBy: 'CreatedOn',
            tagCriteria: {
                    "EntityId": $ctrl.model.entityId,
                    "EntityType": $ctrl.model.entityType
            }
        }).then((res) => $ctrl.messages = res.data.results);
    }

    $ctrl.save = $ctrl.submit = function () {
            bus.send('CreateEntityMessage.json', $ctrl.model.message).then(function (response) {
                $rootScope.$emit('entityMessageSaved', $ctrl);
                //$uibModalInstance.close($ctrl.model);
                $ctrl.model.message.messageText = "";
                $ctrl.loadMessages();
            });
    };
    $ctrl.delete = function() {
        $uibModalInstance.close($ctrl.model);
        return modals.confirm("Are you sure?", "Delete Note").result.then(function () {
            $ctrl.bus.send('DeleteEntityMessage.json', $ctrl.model.message).then(function (response) {
                $rootScope.$emit('entityMessageDeleted', $ctrl);
            });
        });
    }
    $ctrl.dismiss = function () {
        $uibModalInstance.dismiss();
    };

    $ctrl.upload = function($files) {    
        const $ctrl = this;
        if ($files && $files.length) {
          const req = {
            request: {
                realm: "Notes",
                tags: {
                    "EntityId": $ctrl.model.entityId,
                    "EntityType": $ctrl.model.entityType
                }
            },
            files: $files,
            urls: []
        };
    
          $ctrl.bus.upload('CreateMedia.json', req).then(
            res => {
                if (res.data.media.length) {
                    $ctrl.model.message.messageText = res.data.media[0].contentType;
                    $ctrl.model.message.refId = res.data.media[0].url;
                    bus.send('CreateEntityMessage.json', $ctrl.model.message).then(function (response) {
                        $rootScope.$emit('entityMessageSaved', $ctrl);
                        $ctrl.model.message.messageText = "";
                        $ctrl.loadMessages();
                    });
                }
            }, res => modals.alert(JSON.stringify(res),'Could not save media!'));
        }
    }

    $ctrl.openVideoMessage = function() {
        const $ctrl = this;
        VideoMessagePrompt.open({model: $ctrl.model}).then(function(res) {
            $ctrl.model.note.noteText = res.contentType;
            $ctrl.model.note.refId = res.url;
            bus.send('CreateEntityNote.json', $ctrl.model.note).then(function (response) {
                $rootScope.$emit('entityNoteSaved', $ctrl);
                $ctrl.model.note.noteText = "";
                $ctrl.loadNotes();
            });
        });
    }

    $rootScope.$on('videoRecordingSaved', (e,args) => {
        $ctrl.upload(args);
    });

    $ctrl.loadMessages();
}

const EntityMessagePrompt =  {
    open(options) {
        return modals.open(angular.extend({
            size: 'lg',
            templateUrl: templateUrl,
            resolve: {
                options: () => options
            },
            controller: EntityMessagePromptController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};


export default EntityMessagePrompt;